import { Link } from "react-router-dom";
import React from "react";


export default function Health() {
  return (
    <div style={{ background: "#f5f5f5", minHeight: "100vh" }}>
      {/* PAGE CONTAINER */}
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          padding: "30px 20px",
        }}
      >
        {/* CARD */}
        <div
          style={{
            background: "#fff",
            padding: "30px",
            borderRadius: 10,
            boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
          }}
        >
          {/* TITLE */}
          <h1
            style={{
              fontSize: "1.8rem",
              fontWeight: "bold",
              color: "#7b1fa2",
              marginBottom: 12,
            }}
          >
            Conveyr Healthcare (Conveyr Health)
          </h1>

          <p
            style={{
              fontSize: "0.9rem",
              color: "#555",
              lineHeight: 1.6,
              marginBottom: 30,
            }}
          >
            From Diagnostics to a 1,000-Bed Institution — Built on top of the
            Conveyr ecosystem, combining physical healthcare infrastructure with
            digital health-tech and AI-driven insights.
          </p>

          {/* HERO GRID */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "2fr 1fr",
              gap: 16,
              marginBottom: 30,
            }}
          >
            <img
              src={require("../assets/kafeel.png")}
              alt="Hospital"
              style={{
                width: "100%",
                height: 260,
                objectFit: "cover",
                borderRadius: 10,
                boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
              }}
            />

            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              <img
                src={require("../assets/medical-professional-with-patient-consultation.jpg")}
                alt="Patient care"
                style={imageSmall}
              />
              <img
                src={require("../assets/diagnostic-laboratory-equipment-and-test-tubes.jpg")}
                alt="Diagnostics"
                style={imageSmall}
              />
            </div>
          </div>

          {/* PHASE 1 */}
          <Section
            title="Phase 1 — Diagnostics Foundation"
            image={require("../assets/pathology-lab-technician-analyzing-blood-samples.jpg")}
          >
            <p>
              The journey starts with a pathology and diagnostics center as the
              first node.
            </p>
            <Box>
              <ul>
                <li>• Routine pathology tests</li>
                <li>• Preventive health packages</li>
                <li>• Digital test booking via Conveyr</li>
                <li>• Secure digital reports via Drive12</li>
              </ul>
            </Box>
          </Section>

          {/* PHASE 2 */}
          <Section
            title="Phase 2 — Multi-Specialty & 1,000-Bed Hospital"
            image={require("../assets/modern-hospital-ward-with-medical-beds-and-equipme.jpg")}
            reverse
          >
            <Box gradient>
              <ul>
                <li>• Multi-specialty departments</li>
                <li>• Integrated EHR linked to Conveyr</li>
                <li>• AI-assisted triage & risk scoring</li>
                <li>• Smart patient journey management</li>
              </ul>
            </Box>
          </Section>

          {/* PHASE 3 */}
          <Section
            title="Phase 3 — Medicine Production & Research"
            image={require("../assets/pharmaceutical-lab-scientists.png")}
          >
            <Box>
              <ul>
                <li>• Pharmaceutical production units</li>
                <li>• Disease-specific research</li>
                <li>• Academic & institutional collaboration</li>
              </ul>
            </Box>
          </Section>

          {/* DIGITAL DIFFERENTIATOR */}
          <div
            style={{
              background: "linear-gradient(to right,#f3e5f5,#fff)",
              padding: 16,
              borderRadius: 8,
              borderLeft: "4px solid #7b1fa2",
              marginTop: 30,
            }}
          >
            <h3 style={sectionTitle}>Digital Differentiator</h3>
            <p style={text}>
              Every record, prescription, diagnostic and discharge summary lives
              securely inside the Conveyr ecosystem — accessible, shareable, and
              AI-enhanced.
            </p>
          </div>

          {/* BACK */}
          <Link
            to="/product"
            style={{
              display: "inline-block",
              marginTop: 30,
              background: "#7b1fa2",
              color: "#fff",
              padding: "10px 18px",
              borderRadius: 6,
              textDecoration: "none",
              fontSize: "0.85rem",
              fontWeight: 600,
            }}
          >
            ← Back to Product
          </Link>
        </div>
      </div>

      <footer
        style={{
            padding: "2rem 1.5rem",
            textAlign: "center",
            background: "#fff",
            marginTop: "1rem",
            borderTop: "1px solid #e0e0e0",
        }}
        >
        {/* COMPANY */}
        <p style={{ margin: "0 0 0.6rem 0", fontWeight: 600 }}>
            © 2025 Algebracorp OPC Private Limited
        </p>

        {/* ADDRESS */}
        <p style={{ margin: "0 0 1.2rem 0", fontSize: "0.9rem", color: "#555" }}>
            Office Address: 16th Park View, Gaur Yamuna City Greater Noida. Up
        </p>

        {/* SOCIAL ICONS */}
        <div
            style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1.4rem",
            marginBottom: "1rem",
            }}
        >
            {/* WhatsApp */}
            <a
            href="https://wa.me/+917518410292"
            target="_blank"
            rel="noopener noreferrer"
            title="WhatsApp"
            style={{ display: "inline-flex" }}
            >
            <img
                src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                alt="WhatsApp"
                style={{
                height: "28px",
                width: "28px",
                transition: "transform 0.25s ease",
                }}
                onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.15)")}
                onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            />
            </a>

            {/* Instagram */}
            <a
            href="https://www.instagram.com/algebracorp"
            target="_blank"
            rel="noopener noreferrer"
            title="Instagram"
            style={{ display: "inline-flex" }}
            >
            <img
                src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
                alt="Instagram"
                style={{
                height: "28px",
                width: "28px",
                transition: "transform 0.25s ease",
                }}
                onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.15)")}
                onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            />
            </a>

            
        </div>

        {/* TAGLINE */}
        <p style={{ margin: 0, fontSize: "0.85rem", color: "#777" }}>
            Building India’s Next-Generation Digital & Commerce Ecosystems
        </p>
        </footer>
    </div>
  );
}

/* ---------- Helpers ---------- */

const imageSmall = {
  width: "100%",
  height: 120,
  objectFit: "cover" as const,
  borderRadius: 10,
  boxShadow: "0 3px 10px rgba(0,0,0,0.15)",
};

const sectionTitle = {
  fontSize: "1rem",
  fontWeight: "bold",
  color: "#7b1fa2",
  marginBottom: 8,
};

const text = {
  fontSize: "0.85rem",
  color: "#444",
  lineHeight: 1.6,
};

function Section({
  title,
  image,
  reverse,
  children,
}: any) {
  return (
    <div
      style={{
        display: "flex",
        gap: 20,
        marginBottom: 30,
        flexDirection: reverse ? "row-reverse" : "row",
      }}
    >
      <div style={{ flex: 1 }}>
        <h3 style={sectionTitle}>{title}</h3>
        <div style={text}>{children}</div>
      </div>

      <img
        src={image}
        alt={title}
        style={{
          width: 200,
          height: 200,
          objectFit: "cover",
          borderRadius: 10,
          boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
        }}
      />
    </div>
  );
}



function Box({ children, gradient }: any) {
  return (
    <div
      style={{
        background: gradient ? "linear-gradient(to right,#f3e5f5,#fff)" : "#f3e5f5",
        padding: 12,
        borderRadius: 8,
        marginTop: 8,
      }}
    >
      {children}
    </div>
    


  );
}
